import { PosEnumMultiSelect } from 'src/core/POS/PosMultiSelect/PosEnumMultiSelect';
import { ContentId } from 'src/utils/constants/contentId';

import { getDeliveryTypeIcons } from './DeliveryTypeSelector.utils';
import {
  DeliveryTypeMultiSelectorProps,
  useDeliveryTypeSelector,
} from './useDeliveryTypeSelector';

export const DeliveryTypeMultiSelector = ({
  allowCustomDeliveryType,
  placeholderText = ContentId.AllDeliveryOptions,
  valueOptionsContent,
  ...rest
}: DeliveryTypeMultiSelectorProps) => {
  const { moderatedOptionsContent } = useDeliveryTypeSelector({
    allowCustomDeliveryType,
    valueOptionsContent,
  });

  return (
    <PosEnumMultiSelect
      style={{ width: '100%' }}
      {...rest}
      placeholderText={placeholderText}
      valueOptionsContent={moderatedOptionsContent}
      valueOptionsIcon={getDeliveryTypeIcons()}
    />
  );
};
